import { ILoggedCustomer } from "api/types";
import images from "assets";
import Button from "components/common/Button/Button";
import Text from "components/common/Text/Text";
import Widget from "components/common/Widget";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import { load } from "utils/ConfigLoader";

interface IProps {
  loggedCustomer?: ILoggedCustomer;
}

const PointsSummary = ({ loggedCustomer }: IProps) => (
  <React.Fragment>
    <Row justify="center" align="center">
      <Col sm={5}>
        <Text hero center fullWidth>
          {load("purchase.pointsEarned")}
        </Text>
        <Text h5 alternate center fullWidth>
          NEW POINTS EARNED!
        </Text>
      </Col>
      <Col sm={4}>
        <img src={images.goldTrophyIcon} alt="trophy" />
      </Col>
    </Row>
    {loggedCustomer ? (
      <Row justify="center" align="center">
        <Col align="center">
          <Link to="/">
            <br />
            <br />
            <br />
            <Button primary wider>
              Return to Dashboard
            </Button>
          </Link>
        </Col>
      </Row>
    ) : (
      <SignIn />
    )}
  </React.Fragment>
);

const SignIn = () => (
  <React.Fragment>
    <Row>
      <Col align="center">
        <Text h3 alternate>
          Want to Redeem your points?
        </Text>
        <Link to="/signup">
          <Button primary wider>
            Sign up for a new account
          </Button>
        </Link>
      </Col>
    </Row>
    <Row>
      <Col align="center">
        <Text h3 alternate>
          Already have an account?
        </Text>
        <Link to="/login">
          <Button secondary wider>
            Sign in
          </Button>
        </Link>
      </Col>
    </Row>
  </React.Fragment>
);

export default PointsSummary;



// WEBPACK FOOTER //
// ./src/screens/PurchaseComplete/PointsSummary.tsx